import React, { useCallback, useRef, useState } from 'react';
import { Button, Popup } from '@ui';
function UserMenu({ email, items }) {
    const anchor = useRef(null);
    const [open, setOpen] = useState(false);
    const handleOpen = useCallback(() => setOpen(true), []);
    const handleClose = useCallback(() => setOpen(false), []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { ref: anchor, mode: "dark", onClick: handleOpen },
            React.createElement("i", { className: "fa-solid fa-circle-user" }),
            React.createElement("span", { className: "user-info" }, email)),
        React.createElement(Popup, { anchor: anchor.current, show: open, onClose: handleClose, position: "bottom-right" },
            React.createElement(Popup.Section, null,
                React.createElement(Popup.ActionList, null, items.map((item) => (React.createElement("a", { key: item.label, className: "qmb-ui-button", href: item.href, "data-method": item.method },
                    React.createElement("i", { className: item.icon }),
                    item.label))))))));
}
export default UserMenu;
